import { EntityType, Tournament } from "./enums";

export const DetailTabs = {
    UPI: [],
    NETC: ["Amount", "Volume", "No of Banks Live", "Tag Issuance"],
} as const;

export const HEADING_STRINGS = {
    PAYMENTS_VALUE: "Payments Value (in Cr)",
    FASTAG_MONTHLY_VOLUME: "Fastag Monthly Volume",
    PAYMENT_VOLUME: "Payment Volume (in Mn)",
    FASTAG_MONTHLY_AMOUNT: "Fastag Monthly Amount",
    BANK_PARTICIPATION: "Bank Participation and Increase in Tag Issuance",
    TAGS_ISSUED: "No of Tags Issued",
    FASTAG_AMOUNT_AND_VOLUME: "Fastag Monthly Amount  and Volume",
    PAYMENTS_VALUE_AND_VOLUME: "Payments Value (in Cr) and Volume (in Mn)",
};

export const EVENT_NAME = {
    SESSION_START: "session_start",
    LOGIN_SUCCESS: "login_success",
    LOGIN_FAILURE: "login_failure",
    LOGOUT: "logout",
    HOME_CLICK: "home_click",
    ABOUT_US_CLICK: "about_us_click",
    ABOUT_US_OPEN: "about_us_open",
    DISCOVER_CLICK: "discover_click",
    CRICKET_CLICK: "cricket_click",
    DISCOVER_OPEN: "discover_open",
    CRICKET_OPEN: "cricket_open",
    EXPLORE_CLICK: "explore_page_loaded",
    QUERY_CLICK: "explore_query_submitted",
};

export const EVENT_CATEGORY = {
    SESSION: "Session",
    AUTHENTICATION: "Authentication",
    NAVIGATION: "Navigation",
    ACTION: "Action",
};

export const EVENT_ACTION = {
    APP_START: "App Start",
    PAGE_LOAD: "Page Load",
    USER_LOGIN: "User Login",
    USER_LOGOUT: "User Logout",
    CLICK: "Click",
};

export const SOCIAL_MEDIA_LINKS = {
    TWITTER: "https://x.com/thedatamuni",
    INSTAGRAM:
        "https://www.instagram.com/thedatamuni/profilecard/?igsh=MWZoN243cjVha2I3eg==",
    LINKEDIN: "https://www.linkedin.com/company/thedatamuni/",
    YOUTUBE: "https://www.youtube.com/thedatamuni",
};

export const TIME_RANGE_MAPPING: Record<number, string> = {
    1: "1 min",
    5: "5 min",
    15: "15 min",
    30: "30 min",
    0: "Today",
    60: "1Hr",
};

export const INTERNATIONAL_LEAGUE_MATCHES = [
    "Domestic-Firstclass",
    "Domestic-Lista",
    "100 ball",
    "in_tten",
    "Domestic-T20",
];

export const CRICKET_MATCH_TYPE_ID_TO_DISPLAY_TYPE_MAP = {
    "1": "T20I",
    "2": "ODI",
    "3": "Test",
    "6": "T20",
    "Domestic-Firstclass": "Test",
    "Domestic-Lista": "Test",
    "100 ball": "100 ball",
    in_tten: "T10",
    "Youth Test": "Test",
    "Youth ODI": "U19 ODI",
    "Youth T20I": "U19 T20I",
};

export const ENTITY_TO_ENDPOINT_MAPPING: Record<EntityType, string> = {
    [EntityType.CRICKET]: "sport/cricket/series",
    [EntityType.FOOTBALL]: "sport/football/series",
    [EntityType.MOVIE]: "movie/series",
};

export const TOURNAMENT_TO_ENDPOINT_MAPPING: Record<Tournament, string> = {
    [Tournament.IPL2024]: "Indian%20Premier%20League,%202024",
    [Tournament.IPL2025]: "Indian%20Premier%20League,%202025",
    [Tournament.CHAMPIONS_TROPHY]: "ICC%20Champions%20Trophy,%202025",
};

export const CRICKET_MATCH_TYPE_TO_DISPLAY_TYPE_MAP = {
    T20I: "T20I",
    ODI: "ODI",
    Test: "Test",
    "Domestic-T20": "T20",
    "Domestic-Firstclass": "Test",
    "Domestic-Lista": "Test",
    "100 ball": "100 ball",
    in_tten: "T10",
    "Youth Test": "Test",
    "Youth ODI": "U19 ODI",
    "Youth T20I": "U19 T20I",
};

export const TOURNAMENT_SLUG_TO_TITLE_MAP = {
    "champions-trophy-2025": "ICC Champions Trophy 2025",
    "ipl-2025": "Indian Premier League 2025",
    "ipl-2024": "Indian Premier League 2024",
};

export const TOURNAMENT_TITLE_TO_SLUG_MAP = {
    "ICC Champions Trophy 2025": "champions-trophy-2025",
    "Indian Premier League 2025": "ipl-2025",
    "Indian Premier League 2024": "ipl-2024",
};

export const TOURNAMENT_SLUG_TO_SHORT_TITLE_MAP = {
    "champions-trophy-2025": "CT 2025",
    "ipl-2025": "IPL 2025",
    "ipl-2024": "IPL 2024",
};

export const TOURNAMENT_SLUG_TO_CATEGORY_MAP = {
    "champions-trophy-2025": "Champions Trophy",
    "ipl-2025": "IPL,IPL 2025",
    "ipl-2024": "IPL,IPL 2024",
};

export const TOURNAMENT_DETAIL_PAGE_TAB_NAME = {
    LIVE: "Live",
    SUMMARY: "Summary",
    SCOREBOARD: "Scoreboard",
    COMMENTARY: "Commentary",
    STATS: "Stats",
    SQUAD: "Squads",
    PLAYING_XI: "Playing XI",
    FANTASY: "Fantasy",
    PREDICTION_EVENTS: "Prediction Events",
};

export const seriesSlugToCategoryValueMap = {
    "champions-trophy-2025": "Champions Trophy",
    "ipl-2025": "IPL,IPL 2025",
    "ipl-2024": "IPL,IPL 2024",
};

export const WicketType = {
    RETIRED_HURT: "dismissal_type_meta_rh",
    RUN_OUT: "run out",
};
